// Translation: English > Server
const server = Object.freeze({
	errorItems: {
		'err.2FA_already_enabled': 'Two-factor authentication is already enabled.',
		'err.account_disabled': 'This account has been disabled.',
		'err.account_locked_temporary': 'This account is temporarily locked.',
		'err.already_send': 'Please wait a while before sending a new code',
		'err.already_verified': 'This account is already verified.',
		'err.auth_service_down': 'We are sorry. We cannot process your request right now. Please try again later.',
		'err.captcha_validation_failed': 'User authenticity validation has failed.',
		'err.code_sent_recently': 'We have received too many reset requests. Please try again later.',
		'err.email_already_exists': 'The email address already exists.',
		'err.email_is_not_valid': 'The email address is not valid.',
		'err.email_not_exists': 'The email address is not found.',
		'err.exists': 'The user is already a member.',
		'err.exist_email': 'The email address already exists.',
		'err.invalid_code': 'Code is invalid.',
		'err.not_found': 'Not found.',
		'err.user_not_exists': 'User does not exist.',
		'err.wrong_old_password': 'Old password is incorrect',
		'err.wrong_username_or_password': 'The user name, or password you entered is incorrect.',
		'err.wrong_verification_code': 'Verification code is wrong.'
	}
})

// Export
export default server
